<template>
    <div id="entityinfo_main" class="ff-inter fs-normal" :key="new Date().toLocaleDateString()">
        <div id="entityinfo_title" class="">
            <span class="fs-big fc-gray-dark">Entity Details</span>
            <i v-if="!editing" @click="toggle(true)" class="fas fa-pen fc-main bt bt-hover-light"></i>
            <i v-else @click="toggle(false)" class="fas fa-times fc-main bt bt-hover-light"></i>
        </div>
        <div id="entityinfo_info" class="fs-small fw-bold">
            <span>Entity  {{ checked.id }}</span>
        </div>
        <div id="entityinfo_properties" class="ff-inter fs-normal">
            <template v-if="!editing">
                <div v-if="checked.properties.length === 0" class="entityinfo_property_SHOW">
                    <div class="entityinfo_property_SHOW_name fc-gray-dark fs-small">
                        no properties
                    </div>
                </div>
                <div class="entityinfo_property_SHOW" v-for="property in checked.properties">
                    <div class="entityinfo_property_SHOW_name fc-main fs-small">
                        {{ property.name }}
                    </div>
                    <div class="entityinfo_property_SHOW_value fc-gray-dark fs-small">
                        {{ property.value }}
                    </div>
                </div>
            </template>
            <template v-else>
                <property-edit @updateProperty="property_update($event)" @deleteProperty="property_delete($event)" v-for="property in checked.properties" :data="property" :open="(openProperty === property.id)" :key="property.id" @open="openProperty = property.id" @close="openProperty = null"></property-edit>
                <property-create @createProperty="property_create($event)" :open="!openProperty" @open="openProperty = null"></property-create>
            </template>
        </div>
    </div>
</template>

<script>
  import PropertyEdit from './propertyEdit'
  import PropertyCreate from './propertyCreate'
  export default {
    name: 'entityInfo',
    components: { PropertyCreate, PropertyEdit },
    props: {
      checked: {
        type: Object
      }
    },
    data(){
      return{
        editing: false,
        openProperty: null,
      }
    },
    methods: {
      toggle(state){
        this.editing = state;
        state ? this.openProperty = null : ''
      },
      property_update(data){
        this.$store.dispatch('Kvs/api_update_property', data)
      },
      property_delete(data){
        this.$store.dispatch('Kvs/api_delete_property', data)
      },
      property_create(data){
        this.$store.dispatch('Kvs/api_create_property', data)
      }
    }
  }
</script>

<style scoped>
    #entityinfo_main{
        display: flex;
        height: 100%;
        width: 350px;
        flex-direction: column;
    }
    #entityinfo_title{
        display: flex;
        width: calc(100% - var(--layout-padding) * 2 + 2px);
        justify-content: space-between;
        padding: var(--layout-padding);
        align-items: center;
        border-bottom: 1px solid var(--color-gray);
    }
    #entityinfo_title i{
        cursor: pointer;
        align-items: center;
    }
    #entityinfo_info{
        display: flex;
        width: calc(100% - var(--layout-padding) * 2 + 2px);
        padding: var(--layout-padding);
        flex-direction: column;
        border-bottom: 1px solid var(--color-gray);
    }
    .entityinfo_property_SHOW{
         display: flex;
        height: 30px;
        width: calc(100% - var(--layout-padding) * 2 + 2px);
         margin: 5px;
        padding: 5px;
         flex-direction: column;
     }
    .entityinfo_property_SHOW_name{

    }
    .entityinfo_property_SHOW_value{

    }
    .entityinfo_property_EDIT{
        display: flex;
        width: calc(100% - var(--layout-padding) * 2);
        margin: var(--layout-padding);
        flex-direction: column;
    }
    .entityinfo_property_EDIT_name{

    }
    .entityinfo_property_EDIT_value{

    }
</style>
